(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["roman-hero-concept"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const TAG_NAME = 'roman-hero-concept-element';

    if (!customElements.get(TAG_NAME)) {
      class RomanHeroConceptElement extends HTMLElement {
        connectedCallback() {
          if (this._initialized) return;

          this._initialized = true;
          this.slides = Array.from(this.querySelectorAll('[data-roman-slide]'));
          this.pauseButton = this.querySelector('[data-roman-pause]');
          this.pauseLabel = this.querySelector('[data-roman-pause-label]');
          this.currentIndex = Math.max(
            0,
            this.slides.findIndex((slide) => slide.classList.contains('is-active'))
          );
          this.autoplayEnabled = this.dataset.autoplay === 'true';
          this.intervalDuration = Math.max(1000, Number(this.dataset.interval) || 5000);
          this.timer = null;
          this.userPaused = false;
          this.temporarilyPaused = false;
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (this.pauseButton) {
            this.pauseButton.hidden =
              this.reduceMotion || !this.autoplayEnabled || this.slides.length < 2;
          }

          this.handlePauseClick = this.handlePauseClick.bind(this);
          this.handleMouseEnter = this.handleMouseEnter.bind(this);
          this.handleMouseLeave = this.handleMouseLeave.bind(this);
          this.handleFocusIn = this.handleFocusIn.bind(this);
          this.handleFocusOut = this.handleFocusOut.bind(this);
          this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);
          this.handleBlockDeselect = this.handleBlockDeselect.bind(this);

          this.pauseButton?.addEventListener('click', this.handlePauseClick);
          this.addEventListener('mouseenter', this.handleMouseEnter);
          this.addEventListener('mouseleave', this.handleMouseLeave);
          this.addEventListener('focusin', this.handleFocusIn);
          this.addEventListener('focusout', this.handleFocusOut);
          document.addEventListener('visibilitychange', this.handleVisibilityChange);
          document.addEventListener('shopify:block:select', this.handleBlockSelect);
          document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

          this.showSlide(this.currentIndex);

          if (this.canAutoplay()) {
            this.start();
          } else {
            this.updatePauseButton();
          }
        }

        disconnectedCallback() {
          this.stop();
          this._initialized = false;

          this.pauseButton?.removeEventListener('click', this.handlePauseClick);
          this.removeEventListener('mouseenter', this.handleMouseEnter);
          this.removeEventListener('mouseleave', this.handleMouseLeave);
          this.removeEventListener('focusin', this.handleFocusIn);
          this.removeEventListener('focusout', this.handleFocusOut);
          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
        }

        canAutoplay() {
          return (
            this.autoplayEnabled &&
            this.slides.length > 1 &&
            !this.reduceMotion &&
            !this.userPaused &&
            !this.temporarilyPaused &&
            !document.hidden
          );
        }

        showSlide(index) {
          if (!this.slides.length) return;

          this.currentIndex = (index + this.slides.length) % this.slides.length;

          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === this.currentIndex;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
        }

        next() {
          this.showSlide(this.currentIndex + 1);
        }

        start() {
          this.stop();

          if (!this.canAutoplay()) {
            this.updatePauseButton();
            return;
          }

          this.timer = window.setInterval(() => this.next(), this.intervalDuration);
          this.updatePauseButton();
        }

        stop() {
          if (this.timer) {
            window.clearInterval(this.timer);
            this.timer = null;
          }

          this.updatePauseButton();
        }

        handlePauseClick() {
          this.userPaused = !this.userPaused;

          if (this.userPaused) {
            this.stop();
          } else {
            this.start();
          }
        }

        handleMouseEnter() {
          this.temporarilyPaused = true;
          this.stop();
        }

        handleMouseLeave() {
          this.temporarilyPaused = false;
          this.start();
        }

        handleFocusIn() {
          this.temporarilyPaused = true;
          this.stop();
        }

        handleFocusOut(event) {
          if (event.relatedTarget && this.contains(event.relatedTarget)) return;

          this.temporarilyPaused = false;
          this.start();
        }

        handleVisibilityChange() {
          if (document.hidden) {
            this.stop();
          } else {
            this.start();
          }
        }

        handleBlockSelect(event) {
          if (!this.contains(event.target)) return;

          const selectedSlide = event.target.closest('[data-roman-slide]');
          if (!selectedSlide) return;

          const index = this.slides.indexOf(selectedSlide);

          if (index >= 0) {
            this.temporarilyPaused = true;
            this.stop();
            this.showSlide(index);
          }
        }

        handleBlockDeselect(event) {
          if (!this.contains(event.target)) return;

          this.temporarilyPaused = false;
          this.start();
        }

        updatePauseButton() {
          if (!this.pauseButton || !this.pauseLabel) return;

          const paused = this.userPaused || !this.timer;

          this.pauseButton.setAttribute(
            'aria-pressed',
            this.userPaused ? 'true' : 'false'
          );
          this.pauseButton.setAttribute(
            'aria-label',
            this.userPaused ? 'スライドショーを再生' : 'スライドショーを一時停止'
          );
          this.pauseLabel.textContent = paused ? '再生' : '一時停止';
        }
      }

      customElements.define(TAG_NAME, RomanHeroConceptElement);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
